import Swal from 'sweetalert2';
import { axiosAuth } from '../api/api';
import { AxiosError } from 'axios';

export async function subscribeEamil(email: string) {
  const eMailPattern = /^[A-Za-z0-9_.-]+@[A-Za-z0-9-]+.[A-Za-z0-9-]+/;
  email.trim();
  if (!email) {
    Swal.fire('Please key in your email.');
  }
  if (!eMailPattern.test(email)) {
    Swal.fire('Please key in a valid email.');
  }
  try {
    const response = await axiosAuth.post('/news/subscribed_email/', {
      email,
    });
    if (response.status === 200 || response.statusText === 'Created') {
      Swal.fire('Thank you! You have been subscribed!');
    }
  } catch (error: unknown) {
    const axiosError = error as AxiosError;
    if (axiosError?.response?.status === 400) {
      const errorData = axiosError.response.data as { email: string[] };
      Swal.fire(errorData.email[0]);
    } else {
      Swal.fire('Please try again later.');
    }
  }
}
